import { gql } from '@apollo/client';
import { AnalysisInfoFieldsFragment } from '../analysis/fragments';
import { CohortFragment } from '../cohorts';
import { DashboardInstanceFieldsFragment } from '../dashboards';
import {
  CreatorFields,
  EditorFields,
  EntityPermissionFieldsFragment,
} from '../fragments';
import { ImageEmbedFieldsFragment } from '../imageEmbed/fragments';
import { RichTextFieldsFragment } from '../richText/fragments';

const ImageEmbedNoteFieldsFragment = gql`
  fragment ImageEmbedNoteFields on ImageEmbedNote {
    imageEmbed {
      ...ImageEmbedFields
    }
  }
  ${ImageEmbedFieldsFragment}
`;

const DashboardNoteFieldsFragment = gql`
  fragment DashboardNoteFields on DashboardNote {
    dashboard {
      ...DashboardInstanceFields
    }
  }
  ${DashboardInstanceFieldsFragment}
`;

const ReportNoteFieldsFragment = gql`
  fragment ReportNoteFields on ReportNote {
    analysis {
      ...AnalysisInfoFields
    }
  }
  ${AnalysisInfoFieldsFragment}
`;

const CohortNoteFieldsFragment = gql`
  fragment CohortNoteFields on CohortNote {
    cohort {
      ...CohortFields
    }
  }
  ${CohortFragment}
`;

// Add a new fragment for basic scratchpad info without notes
export const ScratchpadBasicFragment = gql`
  fragment ScratchpadBasicFragment on Scratchpad {
    id
    title
    creator {
      ...CreatorFields
    }
    createdAt
    editor {
      ...EditorFields
    }
    editedAt
    shared
    permission {
      ...EntityPermissionFields
    }
  }
  ${EntityPermissionFieldsFragment}
  ${CreatorFields}
  ${EditorFields}
`;

export const RichTextNoteFieldsFragment = gql`
  fragment RichTextNoteFields on RichTextNote {
    richText {
      ...RichTextFields
    }
  }
  ${RichTextFieldsFragment}
`;

export const ScratchpadWithNotesFragment = gql`
  fragment ScratchpadWithNotesFragment on Scratchpad {
    ...ScratchpadBasicFragment
    notes {
      id
      seq
      content {
        ... on RichTextNote {
          ...RichTextNoteFields
        }
        ... on ImageEmbedNote {
          ...ImageEmbedNoteFields
        }
        ... on DashboardNote {
          ...DashboardNoteFields
        }
        ... on ReportNote {
          ...ReportNoteFields
        }
        ... on CohortNote {
          ...CohortNoteFields
        }
      }
    }
  }
  ${ScratchpadBasicFragment}
  ${RichTextNoteFieldsFragment}
  ${ImageEmbedNoteFieldsFragment}
  ${DashboardNoteFieldsFragment}
  ${ReportNoteFieldsFragment}
  ${CohortNoteFieldsFragment}
`;
